<ngx-select aria-expanded="false" role="listbox" id="sortfilter" [(ngModel)]="itemId" [items]="prodSortList"
    optionValueField="value" [noAutoComplete]="true" (focus)="doFocus()" (blur)="doBlur()" (open)="doOpen()"
    (close)="doClose()" (select)="doSelect($event)" (remove)="doRemove($event)"
    (selectionChanges)="doSelectOptions($event)" optionTextField="displayName" placeholder="{{ itemId }}"
    name="sort-filter"></ngx-select>